<template>
	<side-panel-inner
		:headerTitle="`Archive ${singular}`"
		class="p-document-archive"
	>
		<template slot="actions">
			<base-button danger @click="onSubmit" iconBefore="archive"
				>Archive</base-button
			>
		</template>

		<document-meta v-if="formData" :document="formData"></document-meta>

		<hr />

		<p>
			Archiving a {{ singular }} will remove if from any policy listings or
			searches. If the {{ singular }} is referenced anywhere, you can choose to
			redirect users to a replacement {{ singular }}.
		</p>
		<callout type="warning">
			<p>
				This process is <strong>irreversible</strong>. Please ensure you have
				selected the correct {{ singular }} to archive before continuing.
			</p>
		</callout>

		<hr />

		<form-field
			full-width
			:label="`Redirect ${singular}`"
			name="propConfig.name"
			:helperText="
				`If you would like to redirect this ${singular}, you can search for a
			new ${singular} to redirect to.`
			"
		>
			<form-resource
				include-policies
				:include-content="false"
				:showValidTick="false"
				placeholder
				id="propConfig.name"
				name="propConfig.name"
				@change="setRedirect"
				:placeholder-text="`Search for a ${singular}`"
			/>
		</form-field>
	</side-panel-inner>
</template>

<script>
import Callout from '@/components/Containers/BaseCallout'

export default {
	name: 'DocumentEdit',

	components: {
		Callout,
	},

	data() {
		return {
			loading: true,
			formData: null,
			redirectId: null,
			prevUrl: null,
		}
	},

	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.prevUrl = from.fullPath
		})
	},

	methods: {
		setRedirect(res) {
			this.redirectId = JSON.parse(res).documentId
		},
		onSubmit() {
			this.loading = true

			this.$validator.validate().then((result) => {
				if (!result) {
					this.loading = false
					this.showValidationMessage = true
				} else {
					this.$store.dispatch('createDialog', {
						confirm: () => {
							this.$store
								.dispatch('documents/archiveDocument', this.redirectId)
								.then(async (resp) => {
									this.$router.push({
										path: this.prevUrl ? this.prevUrl : `/admin/documents/${plural}`,
									})
									this.$store.dispatch('notifications/create', {
										body: `The ${this.singular} has been archived`,
										type: 'success',
									})
								})
								.catch((err) => {
									this.$store.dispatch('notifications/create', {
										body: `The ${this.singular} has not been archived - ${err}`,
										type: 'danger',
									})
								})
						},
					})
				}
			})
		},

		async retrieveDocument() {
			const vm = this
			const documentId = this.$route.params.id
			let document
			let version

			try {
				document = await this.$store.dispatch('documents/read', documentId)
				this.formData = document

				if (this.$route.params.versionId) {
					const { versionId } = this.$route.params
					version = await this.$store.dispatch('documents/getVersion', {
						documentId,
						versionId,
					})
					this.formData.current_version = version.data.data.version
				}

				this.loading = false
				this.originalUrl = this.formData.current_version.external_url
				if (this.formData.current_version.file) {
					this.showUpload = true
					/**
					 * Fake the file as uploaded
					 * If there is a file
					 */
					this.$store.commit(
						'files/setLocalFile',
						this.formData.current_version.file
					)
					this.$store.commit('files/setUploadPercent', 100)
					this.$store.commit(
						'files/setUploadedFile',
						this.formData.current_version.file
					)
				} else {
					this.showUpload = false
				}
			} catch (err) {
				console.log('TCL: retrieveDocument -> err', err)
			}
		},
	},

	computed: {
		singular() {
			return this.$store.state.documents.docType.singular
		},
		plural() {
			return this.$store.state.documents.docType.plural
		},

		/**
		 * Current version number in float format
		 */
		versionNumber() {
			return parseFloat(this.formData.current_version.version)
				.toPrecision(2)
				.toString()
		},

		documentFileTypes() {
			if (this.docType.singular == 'policy') {
				return ['pdf']
			}

			return null
		},

		docType() {
			return this.$store.state.documents.docType
		},
	},

	beforeMount() {
		// so that the background isn't empty...
		if (
			!this.$store.state.documents[this.$store.state.documents.docType.plural]
		) {
			this.$store.dispatch('documents/list')
		}
	},

	created() {
		this.retrieveDocument()
	},
}
</script>
